module.exports = __webpack_public_path__ + "static/media/In_Print.0d0de912.md";